import React from 'react';
import PropTypes from 'prop-types';
import {
    RadioButton,
    RadioButtonGroup,
} from 'material-ui/RadioButton';

import { Load } from '../../components';
import {
    Utils,
    apiService,
} from '../../services';
import InscricaoStepBoleto from '../inscricao/InscricaoStepBoleto';
import InscricaoStepCartao from '../inscricao/InscricaoStepCartao';
import PrincipalMaster from '../master/Principal';
import PublicMaster from '../master/Public';

class InscricaoOuvinteFormasDePagamento extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            carregando: true,
            dsFormasDePagamento: [],
            formaLogos: 0,
            isVisible: false,
            indexSelecionadoForma: 0,
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        Utils.showLoading(false);
        await this.onGetFormasDePagamentoLogos(this.props.match.params.codigoOuvinte);
    }

    onUpdateStatusLoad(value) {
        this.setState({ carregando: value });
    }

    async onGetFormasDePagamentoLogos(codigoOuvinte) {
        const formasDePagamento = await apiService.getFormasDePagamentoOuvinte(codigoOuvinte);
        this.setState({ dsFormasDePagamento: formasDePagamento, carregando: false }, () => this.onSelectFormasDePagamentoLogos(0));
    }

    async onSelectFormasDePagamentoLogos(indexFormaDeBagamento) {
        const formaSelecionado = this.state.dsFormasDePagamento[indexFormaDeBagamento];
        this.setState({
            isBoleto: !formaSelecionado.PorCartao,
            isVisible: true,
            formaLogos: formaSelecionado.Forma,
        });
    }

    async onPagarComBoleto(nome, email, cpf, dataNascimento, endereco, bairroSelecionado, cidadeSelecionada) {
        this.onUpdateStatusLoad(true);
        const { formaLogos } = this.state;

        try {
            const requestBoleto = await apiService.onPagarComBoletoOuvinte(cpf, dataNascimento, nome, endereco, bairroSelecionado, cidadeSelecionada, email, formaLogos, this.props.match.params.codigoOuvinte);
            if (requestBoleto.message) {
                // Se tiver message é por que deu erro na api.
                Utils.showToast(requestBoleto.message);
                this.onUpdateStatusLoad(false);
                return;
            }
            this.onUpdateStatusLoad(false);
            this.props.history.push(`/inscricao-ouvinte/resumo/${this.props.match.params.codigoOuvinte}`);
        } catch (error) {
            Utils.showToast(error.message);
            this.onUpdateStatusLoad(false);
        }
    }

    async onPagarComCartao(nome, numeroCartao, mesVencimento, anoVencimento, codigoSeguranca, email, cpf, dataNascimento) {
        this.onUpdateStatusLoad(true);
        const { formaLogos } = this.state;

        const { sessionId } = await apiService.getSessionID();
        try {
            const pagSeguro = await apiService.getTokenHash(numeroCartao, mesVencimento, anoVencimento, codigoSeguranca, sessionId);

            const requestPagamentoCartao = await apiService.onPagarComCartaoOuvinte(cpf, dataNascimento, nome, email, formaLogos, this.props.match.params.codigoOuvinte, pagSeguro.Token, pagSeguro.Hash);
            if (requestPagamentoCartao.message) {
                // Se tiver message é por que deu erro na api.
                Utils.showToast(requestPagamentoCartao.message);
                this.onUpdateStatusLoad(false);
                return;
            }
            this.onUpdateStatusLoad(false);
            this.props.history.push(`/inscricao-ouvinte/resumo/${this.props.match.params.codigoOuvinte}`);
        } catch (error) {
            Utils.showToast(error.message);
            this.onUpdateStatusLoad(false);
        }
    }

    getInscricaoStepPagamento(isBoleto) {
        if (isBoleto) {
            return (
                <InscricaoStepBoleto
                    onPagarComBoleto={(nome, email, cpf, dataNascimento, endereco, bairroSelecionado, cidadeSelecionada) =>
                        this.onPagarComBoleto(nome, email, cpf, dataNascimento, endereco, bairroSelecionado, cidadeSelecionada)}
                />
            );
        }
        return (
            <InscricaoStepCartao
                onPagarComCartao={(nome, numeroCartao, mesVencimento, anoVencimento, codigoSeguranca, email, cpf, dataNascimento) =>
                    this.onPagarComCartao(nome, numeroCartao, mesVencimento, anoVencimento, codigoSeguranca, email, cpf, dataNascimento)}
            />
        );
    }

    render() {
        const {
            dsFormasDePagamento,
            isBoleto,
            isVisible,
            indexSelecionadoForma,
            carregando,
        } = this.state;

        const MasterPage = Utils.getUsuarioEstaLogado() ? PrincipalMaster : PublicMaster;

        return (
            <MasterPage title="Inscrição" {...this.props}>
                <div className="padding-content">
                    <h3>Selecione a forma de pagamento</h3>
                    {
                        carregando ?
                            <Load /> :
                            <RadioButtonGroup
                                name="formaDePagamento"
                                value={indexSelecionadoForma}
                                onChange={(_, index) => this.onSelectFormasDePagamentoLogos(index)}
                            >
                                {
                                    dsFormasDePagamento.map((x, index) => <RadioButton key={x.Forma} value={index} label={x.Descricao} />)
                                }
                            </RadioButtonGroup>
                    }
                    {
                        isVisible && this.getInscricaoStepPagamento(isBoleto)
                    }
                </div>
            </MasterPage>
        );
    }
}

InscricaoOuvinteFormasDePagamento.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            codigoOuvinte: PropTypes.string,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default InscricaoOuvinteFormasDePagamento;
